import asaColor from '@asa/asasqt-microfrontend-components/dist/theme/foundations/asaColors';

import { asaServiceColors } from '@/theme/commons/foundations/asaServiceColors';

export const colors = {
  brand: asaServiceColors.gray,
  secondary: asaColor.blue,
  gray: asaColor.gray,
  success: asaColor.green,
  error: asaColor.darkRed,
  warning: asaColor.orange,
  transparent: asaColor.transparent,
};
